import { Face, FaceFilters } from '@/analysis/types';
import { QueryResult } from '@/type';
import api from '@/API';

export default {
  findAll(clientId: number, filters: FaceFilters = {}): Promise<QueryResult<Face>> {
    // Convert boolean assigned filter to string for backend compatibility
    const params: Record<string, unknown> = { ...filters };
    if (typeof filters.assigned === 'boolean') {
      params.assigned = filters.assigned ? 'true' : 'false';
    }

    return api.get(`clients/${clientId}/faces`, { params }).then(response => response.data);
  },

  findByIds(clientId: number, ids: number[]): Promise<QueryResult<Face>> {
    return api
      .get(`clients/${clientId}/faces`, { params: { ids } })
      .then(response => response.data);
  },
};
